import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">热度榜单</h2>
          <p className="section-subtitle">实时热搜榜单，看看今天大家都在围观什么</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-3 md:gap-4 p-4 md:px-6 md:py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-900 truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex items-center gap-1.5 text-xs flex-shrink-0">
                <span className={`${item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'}`}>
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-line"></i>
                  ) : (
                    <i className="ri-arrow-down-line"></i>
                  )}
                </span>
                <span className="text-foreground-600 font-medium">{item.heat}</span>
              </div>

              {item.change !== 0 && (
                <span className={`text-xs font-medium flex-shrink-0 ${
                  item.change > 0 ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  {item.change > 0 ? `↑${item.change}` : `↓${Math.abs(item.change)}`}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}